export const FETCH_CLIENT_SERVICE_VERSIONS = 'FETCH_CLIENT_SERVICE_VERSIONS'
export const SET_DEFAULT_SERVICE_VERSION = 'SET_DEFAULT_SERVICE_VERSION'

export default {
  FETCH_CLIENT_SERVICE_VERSIONS,
  SET_DEFAULT_SERVICE_VERSION
}
